import React from 'react';
import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import SafeDrivingNavigationUpdateBottomSheet from '@di-shared/features/safe-driving-vDSP/SafeDrivingNavigationUpdateBottomSheet';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 400;

function SafeDrivingNavigationUpdateBottomSheetPage() {
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <SafeDrivingNavigationUpdateBottomSheet />
    </BottomSheetWebViewWrapper>
  );
}

export default SafeDrivingNavigationUpdateBottomSheetPage;
